module.exports = __webpack_public_path__ + "img/duetoday@2x.3980403d.png";